'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.millisecondAgo;


// WEBPACK FOOTER //
// ./~/sugar-date/number/millisecondAgo.js